import { create } from "zustand";
import { IMAGE_SEARCH_MAX_RESULTS } from "../utils/image-search";

interface ImageSearchState {
  /** Offers the backend picked for the uploaded photo (best match first); null = text search. */
  offerIds: string[] | null;
  setOfferIds: (offerIds: string[]) => void;
  clear: () => void;
}

/** Search-by-photo mode of the search page. Not persisted. */
export const useImageSearchStore = create<ImageSearchState>((set) => ({
  offerIds: null,
  setOfferIds: (offerIds) =>
    set({
      offerIds:
        offerIds.length > 0 ? offerIds.slice(0, IMAGE_SEARCH_MAX_RESULTS) : null,
    }),
  clear: () => set((state) => (state.offerIds === null ? state : { offerIds: null })),
}));
